import React from "react";
export default function Hero() {
  return (
    <div className="hero">
      <div className="hero-info">
        <h2>Hey! I am Gabrielle.</h2>
        <p> &#9733;I am a Software Developer who loves the constant challenge the development industry gives you.</p>
      </div>
    </div>
  );
}
